module.exports = __webpack_public_path__ + "static/media/400154_02.23d49a44.png";